module.exports = __webpack_public_path__ + "img/website-app.4057d712.png";